import React from 'react';
import ChevronUpDisabled from '../assets/images/ChevronUpDisabled.svg';

export default () => {
  return <img src={ChevronUpDisabled} alt="" />;
};
